import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { Tooltip } from "@/components/General/Tooltip/tooltip.component";

import { Sections } from "../../productComparison.helpers";
import { Cell } from "./Cell/cell.container";

type RowComponentProps = {
    sections: Sections;
    featureName: string;
    sectionName: string;
    products: Array<Product<ProductFieldSet.ProductTile>>;
};

export const RowComponent = ({
    featureName,
    sectionName,
    sections,
    products
}: RowComponentProps) => (
    <div className={cn("tw:flex tw:whitespace-nowrap tw:relative")}>
        <Col
            xs={12}
            className={cn(
                "tw:sticky tw:left-0 tw:top-0 tw:z-1 tw:flex-0 tw:w-0 tw:bg-transparent tw:px-0 tw:text-sm tw:font-bold tw:border-t tw:border-grey-light",
                "tw:md:[@media(min-height:500px)]:flex-[17.5rem] tw:md:[@media(min-height:500px)]:w-70 tw:md:[@media(min-height:500px)]:max-w-70 tw:md:[@media(min-height:500px)]:bg-grey tw:md:[@media(min-height:500px)]:px-4 tw:md:[@media(min-height:500px)]:font-normal tw:md:[@media(min-height:500px)]:text-base"
            )}
        >
            <Row>
                <Col xs={12}>
                    <div
                        className={cn(
                            "tw:py-2 tw:flex tw:items-center",
                            "tw:[@media(max-width:768px),(max-height:799px)]:p-2! tw:[@media(max-width:768px),(max-height:799px)]:px-4! tw:[@media(max-width:768px),(max-height:799px)]:w-50 tw:[@media(max-width:768px),(max-height:799px)]:max-w-50"
                        )}
                    >
                        <span
                            className={cn(
                                "tw:inline-block tw:flex-1 tw:whitespace-nowrap tw:overflow-hidden tw:text-ellipsis",
                                "tw:[@media(max-width:768px),(max-height:799px)]:flex-[unset]"
                            )}
                        >
                            {featureName}
                        </span>
                        {sections[sectionName][featureName].toolTipImage && (
                            <Tooltip title={featureName}>
                                <img
                                    className={cn(
                                        "tw:max-w-full tw:w-auto tw:inline-block"
                                    )}
                                    loading={"lazy"}
                                    decoding={"async"}
                                    alt={
                                        sections[sectionName][featureName]
                                            .toolTipImage?.altText ?? ""
                                    }
                                    src={
                                        sections[sectionName][featureName]
                                            .toolTipImage?.url
                                    }
                                />
                            </Tooltip>
                        )}
                    </div>
                </Col>
            </Row>
        </Col>
        {products.map((product, i) => (
            <Cell
                key={`${i}-${sectionName}-${featureName}`}
                productFeatures={product.features}
                sectionName={sectionName}
                featureName={featureName}
            />
        ))}
    </div>
);
